import { render, staticRenderFns } from "./ProjectQuestionView.vue?vue&type=template&id=c452ed52&scoped=true"
import script from "./ProjectQuestionView.vue?vue&type=script&lang=js"
export * from "./ProjectQuestionView.vue?vue&type=script&lang=js"
import style0 from "./ProjectQuestionView.vue?vue&type=style&index=0&id=c452ed52&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452ed52",
  null
  
)

export default component.exports